import { useService } from '@core/inversify-react';
import { useQuery, UseQueryOptions } from 'react-query';

import { GetBranchesSelectRepoType, IGetBranchesSelectRepo } from '../repos';
import type { IBranchSelect } from '../interfaces';

export const useBranchesSelect = (query = {}, options?: UseQueryOptions<IBranchSelect[], Error, IBranchSelect[], ['branches-select']>) => {
  const getBranchesRepo = useService<IGetBranchesSelectRepo>(GetBranchesSelectRepoType);

  return useQuery<IBranchSelect[], Error, IBranchSelect[], ['branches-select']>(
    ['branches-select'],
    async () => {
      const result = await getBranchesRepo.execute();

      if (result.status === 200) {
        return result.response;
      } else {
        throw new Error(result.response);
      }
    },
    options,
  );
};
